import { getAuthedDataClient } from '@/lib/amplify-client';
import { getRecordLoginUrl, recordLoginLive } from '@/api/recordLogin';
import type { AuthUser } from '@/stores/authStore';

/** Create a Dynamo User row when missing (session restore / first hub load). */
export async function ensureUserProfile(user: AuthUser): Promise<void> {
  try {
    const client = await getAuthedDataClient();
    const existing = await client.models.User.get({ id: user.id });
    if (existing.data) return;

    await client.models.User.create({
      id: user.id,
      email: user.email,
      displayName: user.displayName,
      roles: user.roles,
    });
  } catch (e) {
    console.warn('[ShopGND] Could not sync User profile', e);
  }
}

/** Record sign-in metadata (time, IP, device) via record-login Lambda. */
export async function recordUserLogin(user: AuthUser): Promise<void> {
  await ensureUserProfile(user);
  const loginUrl = await getRecordLoginUrl();
  if (!loginUrl) {
    console.warn('[ShopGND] record-login URL not configured — sign-in audit skipped');
    return;
  }
  try {
    await recordLoginLive();
  } catch (e) {
    console.warn('[ShopGND] Could not record login', e);
  }
}
